import {
    ColorPickerPanel,
    RectangularBoxMarkerBase,
    SvgHelper
} from "markerjs2";

export class StarMarker extends RectangularBoxMarkerBase {
    strokeColor = "transparent";
    strokeWidth = 0;

    constructor(container, overlayContainer, settings) {
        super(container, overlayContainer, settings);

        this.strokeColor = settings.defaultColor;
        this.strokeWidth = settings.defaultStrokeWidth;

        this.createVisual = this.createVisual.bind(this);
        this.setStrokeColor = this.setStrokeColor.bind(this);

        this.strokePanel = new ColorPickerPanel(
            "Line color",
            settings.defaultColorSet,
            settings.defaultColor
        );
        this.strokePanel.onColorChanged = this.setStrokeColor;
    }

    // Método para calcular los puntos de la estrella
    getPoints() {
        const centerX = this.width / 2;
        const centerY = this.height / 2;
        const radius = Math.min(this.width, this.height) / 2;
        const innerRadius = radius / 2; // Radio de la parte interna de la estrella

        const points = [];
        const angleIncrement = (Math.PI * 2) / 5; // Para una estrella de 5 puntas

        for (let i = 0; i < 5; i++) {
            // Puntos exteriores de la estrella
            const outerX = centerX + radius * Math.cos(i * angleIncrement);
            const outerY = centerY + radius * Math.sin(i * angleIncrement);
            points.push(`${outerX},${outerY}`);

            // Puntos internos de la estrella
            const innerX = centerX + innerRadius * Math.cos(i * angleIncrement + angleIncrement / 2);
            const innerY = centerY + innerRadius * Math.sin(i * angleIncrement + angleIncrement / 2);
            points.push(`${innerX},${innerY}`);
        }

        return points.join(" ");
    }

    createVisual() {
        this.visual = SvgHelper.createPolygon(this.getPoints(), [
            ["stroke", this.strokeColor],
            ["fill", "transparent"],
            ["stroke-width", this.strokeWidth.toString()]
        ]);
        this.addMarkerVisualToContainer(this.visual);
    }

    setPoints() {
        super.setSize();
        SvgHelper.setAttributes(this.visual, [["points", this.getPoints()]]);
    }

    pointerDown(point, target) {
        super.pointerDown(point, target);
        if (this.state === "new") {
            this.createVisual();

            this.moveVisual(point);

            this._state = "creating";
        }
    }

    resize(point) {
        super.resize(point);
        this.setPoints();
    }

    pointerUp(point) {
        super.pointerUp(point);
        this.setPoints();
    }

    ownsTarget(el) {
        if (super.ownsTarget(el) || el === this.visual) {
            return true;
        } else {
            return false;
        }
    }

    setStrokeColor(color) {
        this.strokeColor = color;
        if (this.visual) {
            SvgHelper.setAttributes(this.visual, [["stroke", this.strokeColor]]);
        }
    }

    get toolboxPanels() {
        return [this.strokePanel];
    }

    getState() {
        const result = Object.assign(
            {
                strokeColor: this.strokeColor
            },
            super.getState()
        );
        result.typeName = StarMarker.typeName;

        return result;
    }

    restoreState(state) {
        const starState = state;
        this.strokeColor = starState.strokeColor;

        this.createVisual();
        super.restoreState(state);
        this.setPoints();
    }

    scale(scaleX, scaleY) {
        super.scale(scaleX, scaleY);

        this.setPoints();
    }
}

StarMarker.typeName = "StarMarker";
StarMarker.title = "Star marker";
StarMarker.icon = `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 2L14.09 8.26L20.18 8.64L15.45 12.97L16.82 19.07L12 15.77L7.18 19.07L8.55 12.97L3.82 8.64L9.91 8.26L12 2Z" fill="none" stroke="white" stroke-width="2"/></svg>`;
